import { Accordion, Button, Chip, Dropdown, Flex, Icon } from "@goodfill/ui-components";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";

import { BondFilterHeader } from "./BondFilterHeader";
import { BondFilterCriteria } from "./BondFilterCriteria";
import { BondFilterDataConstraints } from "./BondFilterDataConstraints";
import { createDefaultValuesFromConstraints } from "./createDefaultValuesFromConstraints";
import { BondFilter, BondFilterChange } from "./BondFilter";
import { filterPopupDockedState } from "../../../../state";
import OpenFunnel from "../../../../assets/OpenFunnel.svg";
import "./BondFiltersDropdown.scss";

export interface BondFiltersDropdownProps {
  bondFilters: BondFilter[];
  criteria: BondFilterCriteria;
  onFilterChange: (change: BondFilterChange) => void;
  constraints: BondFilterDataConstraints;
}

export const BondFiltersDropdown: React.FC<BondFiltersDropdownProps> = ({
  criteria: currentCriteria,
  constraints,
  onFilterChange,
  bondFilters,
}) => {
  const defaultCriteria = createDefaultValuesFromConstraints(constraints);

  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);

  const [activeCriteria, setActiveCriteria] = useState<BondFilterCriteria>(currentCriteria);
  const [filterIsDocked, setFilterIsDocked] = useRecoilState(filterPopupDockedState);

  useEffect(() => {
    setActiveCriteria(currentCriteria);
  }, [currentCriteria]);

  const onClickClose = () => {
    setFilterIsDocked(false);
    setDropdownIsOpen(false);
  };

  const onClickSubmit = () => {
    onFilterChange({ criteria: activeCriteria });
    // only close if we are not docked
    if (!filterIsDocked) {
      setDropdownIsOpen(false);
    }
  };

  const onClickReset = () => {
    onFilterChange({ criteria: defaultCriteria });
    setActiveCriteria(defaultCriteria);
  };

  const onActiveFilterChange = (change: BondFilterChange) => {
    setActiveCriteria(change.criteria);
  };

  const OnClickDock = () => {
    setFilterIsDocked(!filterIsDocked);
  };
  const submitLabel = "Apply";

  const setIsOpenDropdownFilter = (isOpen: boolean) => {
    // only close if we are not docked
    if (!filterIsDocked) {
      setDropdownIsOpen(isOpen);
    }
  };

  return (
    <Dropdown
      isOpen={dropdownIsOpen}
      setIsOpen={setIsOpenDropdownFilter}
      right={true}
      className={`${filterIsDocked ? "fixed-dropdown overflow-x-scroll" : "filter-dropdown "}`}
      fixed={filterIsDocked}
      trigger={
        <>
          <Chip size="medium" className="p-0-important">
            <Flex direction="row" items="center" gap={2} className="text-[14px]">
              <img src={OpenFunnel} alt="Filter" />
              Filter
              <div>
                <Icon name={dropdownIsOpen ? "caret-up" : "caret-down"} size={12} />
              </div>
            </Flex>
          </Chip>
        </>
      }
    >
      <BondFilterHeader
        title="Filter"
        clickHandlers={{
          onClickReset: onClickReset,
          onClickClose: onClickClose,
          onClickDock: OnClickDock,
        }}
      />
      <div className="custom-scroll hide-scrollbar">
        <Accordion className="BondFiltersDropdown_inlinePadding">
          {bondFilters
            .filter((bondFilter) => bondFilter.isVisibleInDropdown())
            .map((bondFilter, i) => (
              <bondFilter.component
                key={i}
                constraints={constraints}
                criteria={activeCriteria}
                defaultCriteria={defaultCriteria}
                onChange={onActiveFilterChange}
              />
            ))}
        </Accordion>
      </div>

      <Button fill primary={true} onClick={onClickSubmit} className="rounded-[12px] mx-auto">
        {submitLabel}
      </Button>
    </Dropdown>
  );
};
